// Formats an EIN as XX-XXXXXXX, the shape the admin CRM saves (EditEntityModal's `formatEin`).
// Anything but digits is dropped, and digits past the ninth are ignored.
export function formatEin(value: string | null | undefined): string {
    const digits = (value ?? '').replace(/\D/g, '').slice(0, 9);
    return digits.length > 2 ? `${digits.slice(0, 2)}-${digits.slice(2)}` : digits;
}
